export enum locationUserRoles {
    owner = 'Owner',
    // TODO ADD OTHERS
}